import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { LoaderService } from 'src/app/services/loader.service';
import { UsersService } from 'src/app/services/users.service';
import { CartStorage } from 'src/app/storage/cart';
import { ResumeStorage } from 'src/app/storage/resume';
import { MatDialog } from '@angular/material/dialog';
import { DialogInsufficientStock } from '../payment/payment.component';
import { CheckoutStockService } from 'src/app/services/checkout-stock.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit {
  defImgProd: string = 'assets/img/logo_nina_placeholder.jpg';
  dataCookieCart: any = [];
  dataProductsAll: any = [];
  productsCart: any = [];
  cookieBranch: any = {};
  total: number = 0;
  myAddress: any = {};
  mapAddress: any = {};
  addressData: any = {
    names: '',
    last_name: '',
    last_name2: '',
    street: '',
    ext_number: '',
    phone: '',
    email: '',
    zip_code: '',
    state_id: '',
    municipality_id: '',
    locality_id: '',
    state: '',
    municipality: '',
    receive: '',
    references: '',
  };
  loged: boolean = false;
  dataProfile: any;
  dataAddresses: any[] = [];
  productsForResume: any = { products: [], total: 0 };
  dataLocalities: Observable<any[]> = of([]);
  dataMunicipality: any;
  dataState: any;
  shippeable: any = null;
  costoEnvio = 0;
  userPointsData: any = null;
  cartView: any[] = [];

  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public router: Router,
    public cookies: CookieService,
    public apiServices: ApiService,
    public apiUsersServices: UsersService,
    public dialog: MatDialog,
    private checkoutStockService: CheckoutStockService
  ) {
    if (cookies.check('Shippeable')) {
      this.shippeable = cookies.get('Shippeable') == 'true' ? true : false;

      // if (cookies.check('MyAddress')) {
      //   this.mapAddress = JSON.parse(this.cookies.get('MyAddress'));

      //   console.log('Direccion seleccionada cart', this.mapAddress);
      // }

      const savedAddress = localStorage.getItem('MyAddressSelected');
      // console.log('MyAddressSelected:', savedAddress);
      if (savedAddress) {
        try {
          this.mapAddress = JSON.parse(savedAddress);
          // console.log(this.mapAddress)
        }
        catch (error) {
          console.error('Error al leer MyAddressSelected:', error);
          this.mapAddress = {};
        }
      }
      else {
        this.mapAddress = {};
      }

      this.initializeAddressData();

      if (CartStorage.exists()) {
        this.dataCookieCart = CartStorage.getCart();
      }

      this.loged = cookies.check('UL');

      this.coreService.emitSubjet.subscribe((response) => {
        if (response.type === 'RefreshLoged') {
          this.loged = cookies.check('UL');
          this.getDataProfile();
          this.getDataAddresses();
        }
      });
    }
  }

  ngOnInit(): void {
    if (this.cookies.check('Branch')) {
      this.getProductsSucursal();
    }

    if (this.cookies.check('UL')) {
      this.getDataProfile();
      this.getDataAddresses();
    }

    const affectedProducts = this.checkoutStockService.consumePendingProducts();
    if (affectedProducts) {
      this.dialog.open(DialogInsufficientStock, {
        width: window.innerWidth <= 768 ? '92vw' : '560px',
        maxWidth: '95vw',
        height: 'auto',
        maxHeight: '90vh',
        backdropClass: 'nina-dialog-backdrop',
        data: { products: affectedProducts }
      });
    }
  }

  sendRegisterCarlos() {
    const now = new Date();
    const fechaRegistroApp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    const birth = new Date(this.dataProfile.birthdate);
    const fechaNacimiento = `${birth.getUTCFullYear()}-${String(birth.getUTCMonth() + 1).padStart(2, '0')}-${String(birth.getUTCDate()).padStart(2, '0')}`;
    let sexo = 'Otro';

    if (this.dataProfile.gender === 'M') sexo = 'Masculino';
    else if (this.dataProfile.gender === 'F') sexo = 'Femenino';
    else if (this.dataProfile.gender === 'O') sexo = this.dataProfile.gender_value || 'Otro';

    const bodyReq: any = {
      idCliente: this.dataProfile.id,
      nombres: this.dataProfile.names,
      paterno: this.dataProfile.last_name,
      materno: this.dataProfile.last_name2,
      celular: this.dataProfile.phone,
      correo: this.dataProfile.email || '',
      fechaNacimiento: fechaNacimiento,
      sexo: sexo,
      codigoPostal: this.dataProfile.main_zip_code,
      colonia: this.dataProfile.locality?.name || '',
      fechaRegistroApp: fechaRegistroApp,
      validar: false,
    };

    this.apiServices.insertaModificaCliente(bodyReq).subscribe({
      next: (value) => { },
      error: (err) => {
        console.error('ERROR', err);
      },
    });
  }

  summonLogin() {
    this.coreService.emitSubjet.next({
      type: 'LoginExternal',
      payload: null,
    });
  }

  getPuntosPorUsuario() {
    let data = {
      token: this.cookies.get('Token'),
      idCliente: this.dataProfile.id,
    };

    this.apiServices.getPuntosPorUsuario(data).subscribe({
      next: (value) => {
        if (value.length > 0) {
          this.userPointsData = value[0];
          this.loaderService.hide();
        } else {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'Hubo un error al procesar tu solicitud' },
          });
        }

        this.loaderService.hide();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });

        console.error(err);
        this.loaderService.hide();
      },
    });
  }

  getDataProfile() {
    this.loaderService.show();

    this.apiUsersServices.me().subscribe({
      next: (value) => {
        if (value.status) {
          this.dataProfile = value.data;

          if (this.dataProfile.phone[0] == '5' && this.dataProfile.phone[1] == '2') {
            this.dataProfile.phone = this.dataProfile.phone.substring(2);
          }

          this.addressData.names = this.dataProfile.names ?? '';
          this.addressData.last_name = this.dataProfile.last_name ?? '';
          this.addressData.last_name2 = this.dataProfile.last_name2 ?? '';
          // this.addressData.phone = this.dataProfile.phone ?? '';
          this.addressData.phone = this.mapAddress.phone ? String(this.mapAddress.phone).replace(/^52/, '') : (this.dataProfile.phone ?? '');
          this.addressData.email = this.dataProfile.email ?? '';
          this.mapAddress.accountPhone = this.dataProfile.phone ?? '';

          this.getPuntosPorUsuario();
          this.sendRegisterCarlos();
        } else {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'Hubo un error al procesar tu solicitud' },
          });
        }
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });

        console.error(err);
        this.loaderService.hide();
      },
    });
  }

  debugAddressValidation(): void {
    const data = this.addressData;

    const validations = [
      {
        campo: 'names',
        valido: !!data.names && String(data.names).trim().length >= 3 && String(data.names).trim().length <= 32,
        valor: data.names
      },
      {
        campo: 'last_name',
        valido: !!data.last_name && String(data.last_name).trim().length >= 3 && String(data.last_name).trim().length <= 32,
        valor: data.last_name
      },
      {
        campo: 'last_name2',
        valido: !!data.last_name2 && String(data.last_name2).trim().length >= 3 && String(data.last_name2).trim().length <= 32,
        valor: data.last_name2
      },
      {
        campo: 'street',
        valido: !!data.street && String(data.street).trim().length >= 3 && String(data.street).trim().length <= 32,
        valor: data.street
      },
      {
        campo: 'ext_number',
        valido: data.ext_number != null && String(data.ext_number).trim().length >= 1 && String(data.ext_number).trim().length <= 32,
        valor: data.ext_number
      },
      {
        campo: 'phone',
        valido: /^\d+$/.test(String(data.phone)) && String(data.phone).length === 10,
        valor: data.phone
      },
      {
        campo: 'email',
        valido: !!data.email &&
          String(data.email).trim().length >= 8 &&
          String(data.email).trim().length <= 128 &&
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(data.email).trim()),
        valor: data.email
      },
      {
        campo: 'zip_code',
        valido: !!data.zip_code && String(data.zip_code).length === 5,
        valor: data.zip_code
      },
      {
        campo: 'state_id',
        valido: data.state_id != null && String(data.state_id).trim() !== '',
        valor: data.state_id
      },
      {
        campo: 'municipality_id',
        valido: data.municipality_id != null && String(data.municipality_id).trim() !== '',
        valor: data.municipality_id
      },
      {
        campo: 'locality_id',
        valido: data.locality_id != null && String(data.locality_id).trim() !== '',
        valor: data.locality_id
      },
      {
        campo: 'references',
        valido: data.references != null &&
          String(data.references).trim().length >= 1 &&
          String(data.references).trim().length <= 254,
        valor: data.references
      },
      {
        campo: 'receive',
        valido: !data.receive ||
          (String(data.receive).trim().length >= 1 && String(data.receive).trim().length <= 32),
        valor: data.receive
      }
    ];

    console.table(
      validations.map(validation => ({
        campo: validation.campo,
        valido: validation.valido ? 'Sí' : 'NO',
        valor: validation.valor
      }))
    );

    const invalidFields = validations
      .filter(validation => !validation.valido)
      .map(validation => validation.campo);

    console.warn(
      invalidFields.length
        ? `Validaciones fallidas: ${invalidFields.join(', ')}`
        : 'Todas las validaciones pasaron.'
    );
  }

  getDataAddresses() {
    this.loaderService.show();

    this.apiUsersServices.getAddress().subscribe({
      next: (value) => {
        if (value.status) {
          this.dataAddresses = value.data;
        } else {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'Hubo un error al procesar tu solicitud' },
          });
        }

        this.loaderService.hide();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });

        console.error(err);
        this.loaderService.hide();
      },
    });
  }


  initializeAddressData(): void {
    const address = this.mapAddress || {};

    this.addressData.street = address.street || '';
    this.addressData.ext_number = address.ext_number || '';
    this.addressData.zip_code = String(address.zip_code || '');
    this.addressData.phone = String(address.phone || '').replace(/^52/, '');

    this.addressData.receive = address.receiving_name || '';
    this.addressData.references = address.references || '';

    this.addressData.locality_id =
      address.locality?.id ??
      address.locality_id ??
      '';

    this.addressData.municipality_id =
      address.municipality?.id ??
      address.municipality_id ??
      '';

    this.addressData.state_id =
      address.state?.id ??
      address.state_id ??
      '';

    this.addressData.municipality =
      address.municipality?.name ??
      address.municipality ??
      '';

    this.addressData.state =
      address.state?.name ??
      address.state ??
      '';
  }


  getProducts() {
    this.loaderService.show();

    let data = {
      token: this.cookies.get('Token'),
    };

    this.apiServices.getProductos(data).subscribe({
      next: (value) => {
        this.dataProductsAll = value;

        this.productsCart = [];

        if (this.dataCookieCart.length > 0) {
          this.dataCookieCart.forEach((elementCart: any) => {
            const productFromApi = this.dataProductsAll.find(
              (element: any) => element.idProducto === elementCart.idProducto
            );

            const product = {
              ...(productFromApi ?? {}),
              ...elementCart,
            };

            this.productsCart.push(this.normalizeCartProduct(product));
          });
        }
        else {
          if (this.cookies.check('Branch')) {
            this.cookies.delete('Branch');
            this.cookies.delete('Shippeable');
            localStorage.removeItem('MyAddressSelected');
          }
        }
        this.coreService.emitSubjet.next({ type: 'Cart', payload: null })
        this.calculateTotal();
        this.buildCartView();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({ type: 'Cart', payload: null })
        this.loaderService.hide();
      },
    });
  }

  getProductosAgrupados() {
    if (this.cookies.check('Branch')) {
      this.cookieBranch = JSON.parse(this.cookies.get('Branch'));

      let data = {
        token: this.cookies.get('Token'),
        idSucursal: this.cookieBranch.idSucursal,
      };

      this.loaderService.show();

      this.apiServices.getProdutosAgrupadoresPorSucursal(data).subscribe({
        next: (value) => {
          this.productsCart.forEach((product: any) => {
            const match = value.find((v: any) => v.idProductoAgrupador === product.idProductoAgrupador);

            if (match) {
              product.productoAgrupador = match.productoAgrupador;
              product.urlFotoAgrupador = match.urlFoto;

              const item = this.dataCookieCart.find((c: any) => c.idProducto === product.idProducto);

              if (item) {
                item.productoAgrupador = match.productoAgrupador;
                item.urlFotoAgrupador = match.urlFoto;
              }
            }
          });

          CartStorage.saveCart(this.dataCookieCart);
          this.coreService.emitSubjet.next({ type: 'Cart', payload: null })
          this.loaderService.hide();
        },
        error: () => {
          this.coreService.emitSubjet.next({ type: 'Cart', payload: null })
          this.loaderService.hide();
        },
      });
    }
  }

  getProductsSucursal() {
    if (this.cookies.check('Branch')) {
      this.loaderService.show();
      this.cookieBranch = JSON.parse(this.cookies.get('Branch'));

      let data = {
        token: this.cookies.get('Token'),
        idSucursal: this.cookieBranch.idSucursal,
      };

      this.apiServices.getProductosPorSucursal(data).subscribe({
        next: (value) => {
          this.dataProductsAll = value;
          this.coreService.emitSubjet.next({ type: 'Cart', payload: null })
          this.productsCart = [];

          if (this.dataCookieCart.length > 0) {
            this.dataCookieCart.forEach((elementCart: any) => {
              const productFromApi = this.dataProductsAll.find(
                (element: any) => element.idProducto === elementCart.idProducto
              );

              const product = {
                ...(productFromApi ?? {}),
                ...elementCart,
              };

              this.productsCart.push(this.normalizeCartProduct(product));
            });

            this.getProductosAgrupados();
          }
          else {
            if (this.cookies.check('Branch')) {
              this.cookies.delete('Branch');
              this.cookies.delete('Shippeable');
              localStorage.removeItem('MyAddressSelected');
              this.shippeable = null;
            }
          }
          this.coreService.emitSubjet.next({ type: 'Cart', payload: null })
          this.calculateTotal();
          this.buildCartView();
        },
        error: (err) => {
          this.coreService.emitSubjet.next({ type: 'Cart', payload: null })
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'Hubo un error al recuperar los datos de tu carrito' },
          });
          this.loaderService.hide();
        },
      });
    }
  }

  private normalizeCartProduct(product: any): any {
    const nombre =
      product?.productoAgrupador?.trim() ||
      product?.producto?.trim() ||
      product?.nombre?.trim() ||
      product?.descripcionProducto?.trim() ||
      '';

    return {
      ...product,
      productoAgrupador: nombre,
    };
  }

  deleteProduct(product: any) {
    if (product.promo && product.married) {
      this.dataCookieCart = this.dataCookieCart.filter((item: any) => item.married !== product.married);
    } else {
      this.dataCookieCart.splice(this.dataCookieCart.findIndex((element: any) => element.idProducto === product.idProducto), 1);
    }

    CartStorage.saveCart(this.dataCookieCart);
    this.productsCart = [];

    this.dataCookieCart.forEach((elementCart: any) => {
      this.productsCart.push({
        ...this.dataProductsAll.find((element: any) => element.idProducto === elementCart.idProducto),
        ...elementCart,
      });
    });

    if (this.dataCookieCart.length <= 0) {
      this.cookies.delete('Branch');
      this.cookies.delete('Shippeable');
      this.shippeable = null;
      localStorage.removeItem('MyAddressSelected');
    }

    this.calculateTotal();
    this.buildCartView();

    this.coreService.emitSubjet.next({
      type: 'Cart',
      payload: null,
    });
  }

  changeQty(action: string, product: any) {
    const itemIndex = this.productsCart.findIndex((p: any) => p.idProducto === product.idProducto);
    if (itemIndex === -1) return;

    const item = this.productsCart[itemIndex];

    switch (action) {
      case 'sumar':
        if (item.qty < product.existencia) {
          item.qty++;
        } else {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'No hay suficiente existencia de este producto :(' },
          });
        }
        break;

      case 'restar':
        if (item.qty > 1) {
          item.qty--;
        }
        break;

      case 'remover':
        this.productsCart.splice(itemIndex, 1);
        break;
    }

    if (this.productsCart.length > 0) {
      this.productsCart = this.productsCart.map((cartItem: any) => {
        const productData = this.dataProductsAll.find(
          (product: any) => product.idProducto === cartItem.idProducto
        );

        return this.normalizeCartProduct({
          ...(productData ?? {}),
          ...cartItem,
        });
      });

      this.calculateTotal();
      this.buildCartView();
      CartStorage.saveCart(this.productsCart);
    } else {
      CartStorage.clear();
    }

    this.coreService.emitSubjet.next({
      type: 'Cart',
      payload: null,
    });
  }

  buy() {
    this.loaderService.show();

    const myColonia =
      this.mapAddress?.locality?.name ||
      this.mapAddress?.user_address?.locality?.name ||
      '';

    let requestBodyNina: any = {
      idSucursal: this.cookieBranch.idSucursal,
      articulos: 0,
      importe: this.total,
      cliente: this.shippeable
        ? (() => {
          const fullName = `${this.addressData.names || ''} ${this.addressData.last_name || ''} ${this.addressData.last_name2 || ''}`.trim();
          const receive = this.addressData.receive?.trim() || fullName;
          return `${fullName} - Recibe: ${receive}`;
        })()
        : (() => {
          const fullName = `${this.dataProfile.names || ''} ${this.dataProfile.last_name || ''} ${this.dataProfile.last_name2 || ''}`.trim();
          return fullName;
        })(),
      Direccion: this.shippeable
        ? `${this.addressData.municipality}, ${this.addressData.state}, ${this.addressData.zip_code}, ${myColonia}, ${this.addressData.street} ${this.addressData.ext_number} Referencias: ${this.addressData.references}`
        : '',
      Celular: this.shippeable
        ? `${this.addressData.phone}`
        : `${this.dataProfile.phone}`,
      EntregaADomicilio: this.shippeable,
      idCliente: this.dataProfile.id,
      listaDeProductos: [],
    };

    this.productsCart.forEach((element: any) => {
      requestBodyNina.listaDeProductos.push({
        idProducto: element.idProducto,
        cantidad: element.qty,
        precio: element.precioPromocionPorProducto ?? element.precioPromocion ?? element.precioNormal ?? element.precioVenta,
        idOferta: element.idPromo ? element.idPromo : 0,
        productoObligatorio: element.tipo == 3 || element.tipo == 5,
        cantidadPromocion: element.cantidad ? element.cantidad : 0,
      });

      requestBodyNina.articulos += element.qty;
    });

    this.productsForResume.products = this.productsCart;
    this.productsForResume.total = this.total;
    this.productsForResume.shippeable = this.shippeable;
    this.productsForResume.branch = this.cookieBranch;
    requestBodyNina.importeEnvioADomicilio = this.costoEnvio;

    const tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);

    localStorage.setItem('Data', JSON.stringify(requestBodyNina));

    const userData = {
      ...this.addressData,
      accountPhone: this.mapAddress.accountPhone,
    };

    this.cookies.set('CartUD', JSON.stringify(userData), {
      expires: tomorrow,
      sameSite: 'Strict',
    });

    ResumeStorage.saveResume(this.productsForResume);
    this.loaderService.hide();

    this.router.navigate(['payment']).then(
      result => console.log('[BUY] Navegación result:', result),
      error => console.error('[BUY] Error de navegación:', error)
    );
  }

  calculateTotal() {
    this.total = 0;

    this.productsCart.forEach((element: any) => {
      this.total += this.getProductPrice(element) * element.qty;
    });

    this.total = Math.floor(this.total);
  }

  searchDataZipCode() {
    const theZipCode = this.addressData.zip_code;

    if (theZipCode.length == 5) {
      this.loaderService.show();

      this.apiUsersServices.getLocalitiesByZipCode(theZipCode).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: value.message },
          });

          if (value.status) {
            this.dataLocalities = of(value.data);
            this.onSelectionLocality({
              value: this.addressData.locality_id + '',
            });
          }

          this.loaderService.hide();
        },
        error: (err) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'Hubo un error al procesar tu solicitud' },
          });

          this.loaderService.hide();
        },
      });
    }
  }

  onSelectionLocality(event: any) {
    let theLocality: any;

    this.dataLocalities.forEach((localities: any) => {
      theLocality = localities.find((locality: any) => locality.id === parseInt(event.value));

      if (theLocality != undefined) {
        this.addressData.locality_id = theLocality.id;
        this.addressData.municipality_id = theLocality.municipality.id;
        this.addressData.state_id = theLocality.state.id;
        this.addressData.municipality = theLocality.municipality.name;
        this.addressData.state = theLocality.state.name;
      }
    });
  }

  isAddressValid(): boolean {
    const data = this.addressData;
    // Descomentar temporalmente para diagnosticar:
    // this.debugAddressValidation();
    const requiredTextFields = ['names', 'last_name', 'last_name2', 'street'];

    for (const field of requiredTextFields) {
      // console.table(this.addressData);
      const value = data[field];

      if (value === null || value === undefined || String(value).trim() === '') {
        return false;
      }
    }

    if (String(data.names).trim().length < 3 || String(data.names).trim().length > 32) return false;
    if (String(data.last_name).trim().length < 3 || String(data.last_name).trim().length > 32) return false;
    if (String(data.last_name2).trim().length < 3 || String(data.last_name2).trim().length > 32) return false;
    if (String(data.street).trim().length < 3 || String(data.street).trim().length > 32) return false;

    if (data.ext_number === null || data.ext_number === undefined || String(data.ext_number).trim() === '') return false;
    if (String(data.ext_number).trim().length < 1 || String(data.ext_number).trim().length > 32) return false;

    if (!/^\d+$/.test(String(data.phone))) return false;
    if (String(data.phone).length !== 10) return false;

    if (data.email === null || data.email === undefined || String(data.email).trim() === '') return false;
    if (String(data.email).trim().length < 8 || String(data.email).trim().length > 128) return false;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(data.email).trim())) {
      return false;
    }

    if (data.zip_code === null || data.zip_code === undefined || String(data.zip_code).trim() === '') return false;
    if (String(data.zip_code).length !== 5) return false;

    if (data.state_id === null || data.state_id === undefined || String(data.state_id).trim() === '') return false;
    if (data.municipality_id === null || data.municipality_id === undefined || String(data.municipality_id).trim() === '') return false;
    if (data.locality_id === null || data.locality_id === undefined || String(data.locality_id).trim() === '') return false;

    if (data.references === null || data.references === undefined || String(data.references).trim() === '') return false;
    if (String(data.references).trim().length < 1 || String(data.references).trim().length > 254) return false;

    if (data.receive && (String(data.receive).trim().length < 1 || String(data.receive).trim().length > 32)) return false;
    return true;
  }

  debugBuyClick(): void {
    // console.log('--- Diagnóstico botón de compra ---');
    // console.log('Productos:', this.productsCart.length);
    // console.log('shippeable:', this.shippeable);
    // console.log('isAddressValid():', this.isAddressValid());
    // console.log('Botón debería estar disabled:',
    //   this.productsCart.length <= 0 ||
    //   (this.shippeable && !this.isAddressValid())
    // );

    // console.log('Dirección:', this.addressData);

    this.buy();
  }

  buildCartView() {
    const grouped: any = {};
    const singles: any[] = [];

    this.productsCart.forEach((product: any) => {
      if (product.promo === true) {
        if (product.married) {
          if (!grouped[product.married]) {
            grouped[product.married] = {
              type: 'promo',
              married: product.married,
              products: [],
              total: 0,
            };
          }

          grouped[product.married].products.push(product);
          grouped[product.married].total += this.getProductPrice(product) * product.qty;
        } else {
          singles.push({
            type: 'promo',
            married: null,
            products: [product],
            total: this.getProductPrice(product) * product.qty,
          });
        }

        return;
      }

      singles.push({
        type: 'single',
        married: null,
        products: [product],
        total: this.getProductPrice(product) * product.qty,
      });
    });

    this.cartView = [...singles, ...Object.values(grouped)];
  }

  getOriginalPrice(product: any): number | null {
    if (product.precioPromocionPorProducto != null) {
      const original = product.precioNormal ?? product.precioVenta;

      if (original != null) {
        return Number(original);
      }
    }

    if (product.precioPromocion != null) {
      const original = product.precioNormal ?? product.precioVenta;

      if (original != null) {
        return Number(original);
      }
    }

    return null;
  }

  hasDiscount(product: any): boolean {
    const original = this.getOriginalPrice(product);
    const finalPrice = this.getProductPrice(product);
    // console.log(original)
    // console.log(finalPrice)
    return original !== null && original > finalPrice;
  }

  getProductPrice(product: any): number {
    if (product.precioPromocionPorProducto != null) {
      return Number(product.precioPromocionPorProducto);
    }

    if (product.precioPromocion != null) {
      return Number(product.precioPromocion);
    }

    if (product.precioNormal != null) {
      return Number(product.precioNormal);
    }

    if (product.precioVenta != null) {
      return Number(product.precioVenta);
    }

    return 0;
  }
}
